export default {
  authTbAccountName: state => {
    return state.authTbAccountName
  },
  authTbAccountRelationId: state => {
    return state.authTbAccountRelationId
  },
  navigationTitle: state => {
    return state.navigationTitle
  },
  fromSourceUrl: state => {
    return state.fromSourceUrl
  },
  mobile: state => {
    return state.mobile
  },
  token: state => {
    return state.token
  },
  userUnionID: state => {
    return state.userUnionID
  },
  userInfo: state => {
    return state.userInfo
  },
}
